import { render, staticRenderFns } from "./GiftProductInfoModal.vue?vue&type=template&id=44f1da28&"
import script from "./GiftProductInfoModal.vue?vue&type=script&lang=js&"
export * from "./GiftProductInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f1da28')) {
      api.createRecord('44f1da28', component.options)
    } else {
      api.reload('44f1da28', component.options)
    }
    module.hot.accept("./GiftProductInfoModal.vue?vue&type=template&id=44f1da28&", function () {
      api.rerender('44f1da28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/modules/GiftProductInfoModal.vue"
export default component.exports